/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { DataGridPro, GridActionsCellItem } from '@mui/x-data-grid-pro';
import apiAdmin from '../../services/api-admin';
import {  MdDelete } from 'react-icons/md';

const ForeclosureSaleActivities = ({ setForeclosureSaleActivityIdToDelete, foreclosureSaleId, activityDeleted, setActivityDeleted}) => {
    const [submitted, setSubmitted] = useState(false);
    const [activities, setActivities] = useState([]);
    const [loadingActivities, setLoadingActivities] = useState(false);

    const columns = [
        { field: 'changeDate', headerName: 'Change Date', flex: 250, renderCell: function (t) { return t.value.toLocaleString("en-US")}  },
        { field: 'note', headerName: 'Note', flex: 500 },
        { field: 'saleDate', headerName: 'Previous Scheduled Sale Date', flex: 250, renderCell: function (t) { if (!t.value) return <></>; return t.value.toLocaleString("en-US").replace(':00 ', ' ')} },

        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            flex: 75,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                if (!parseInt(id)) return [];
                return [                                            
                    <GridActionsCellItem
                        icon={<MdDelete />}
                        label="Delete"
                        onClick={() => { setForeclosureSaleActivityIdToDelete(id); setActivityDeleted(false)  }}
                        color="inherit"
                        data-bs-toggle="modal" 
                        data-bs-target="#deleteActivityModal" role="button" 
                    />,
                ];
            }
        }
    ];

    useEffect(() => {
        const getActivities = async () => {
            setLoadingActivities(true);
            apiAdmin.get(`/foreclosure-sale-activities?foreclosureSaleId=`+ foreclosureSaleId)
                .then((response) => {
                    setActivities(response.data.map(r => ({
                        id: r.foreclosureSaleActivityId,
                        changeDate: new Date(r.changeDate),
                        note: r.note,
                        saleDate: r.saleDate ? new Date(r.saleDate) : null,
                    })));
                    setLoadingActivities(false);
                });
        }

        getActivities();

    }, [submitted, foreclosureSaleId, activityDeleted]);
    
    return (
        <div>
                {submitted && <><div className="alert alert-success alert-dismissible" role="alert">Activity saved successfully!<button type="button" className="btn-close" onClick={() => setSubmitted(false)} aria-label="Close"></button></div></>}
                {activityDeleted &&  <div className="alert alert-warning alert-dismissible" role="alert">Activity deleted successfully!<button type="button" className="btn-close" onClick={() => setActivityDeleted(false)} aria-label="Close"></button></div>}

                <DataGridPro
                    rows={activities}
                    columns={columns}
                    loading={loadingActivities}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'skeleton',
                            noRowsVariant: 'skeleton',
                        },
                    }}
                    autoHeight
                    rowHeight={38}
                    disableRowSelectionOnClick
                    alignItems="center"
                    hideFooter
                    />
        </div>
    );
}

export default ForeclosureSaleActivities;
